"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagClear = void 0;
var react_1 = __importDefault(require("react"));
var Tag_1 = require("../Tag");
var TagClear = function (_a) {
    var id = _a.id, display = _a.display, size = _a.size, onClick = _a.onClick, fill = _a.fill, weight = _a.weight, badgeColor = _a.badgeColor;
    return (react_1.default.createElement(Tag_1.Tag, { id: id, display: display, icon: "X", size: size, onClick: onClick, variant: "clear", fill: fill, weight: weight, badgeColor: badgeColor }));
};
exports.TagClear = TagClear;
